import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

// **La police de la maquette, hébergée avec l'application.**
//
// `jetons.css` déclarait « IBM Plex Sans » depuis le premier jour, et personne
// ne la chargeait : tout retombait sur `system-ui`. Une valeur exacte dans un
// jeton ne sert à rien si le fichier n'arrive jamais — et c'est l'écart le
// plus visible qu'il y avait avec la référence.
//
// Servie depuis nos propres assets, non depuis Google Fonts : la politique de
// sécurité du portail n'admet que `font-src 'self' data:`, et un cabinet dont
// le réseau filtre les domaines tiers verrait sinon l'interface changer de
// visage sans que rien ne le signale.
//
// Quatre graisses, celles que la maquette emploie. Chacune est un fichier de
// plus à charger ; en prendre neuf « au cas où » se paierait à l'ouverture.
//
// **Les sous-ensembles latins seulement.** Le paquet complet en pose neuf —
// cyrillique, grec, vietnamien — soit 2,2 Mo dans l'image dont le navigateur
// ne prendra jamais un octet pour du français. `latin-ext` reste, lui : les
// noms des intervenants d'un chantier ne s'arrêtent pas au latin-1.
import "@fontsource/ibm-plex-sans/latin-400.css";
import "@fontsource/ibm-plex-sans/latin-500.css";
import "@fontsource/ibm-plex-sans/latin-600.css";
import "@fontsource/ibm-plex-sans/latin-700.css";
import "@fontsource/ibm-plex-sans/latin-ext-400.css";
import "@fontsource/ibm-plex-sans/latin-ext-600.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "./jetons.css";
import "./app.css";

const racine = document.getElementById("racine");
if (!racine) throw new Error("L'élément racine est absent de index.html.");

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
